import React from 'react'
import PropTypes from 'prop-types'
import {Header, Tab} from 'semantic-ui-react'
import './ContentView.scss'

import {getLanguageScope} from '../../../helpers'
import ReportsView from "../../../components/Reports/containers/ReportsViewContainer";
import TransactionsView from "../../../components/Transactions/containers/TransactionsViewContainer";
import ClerksView from '../../../components/Clerks/containers/ClerksViewContainer'

import {ACCOUNT_TABS} from "../../../constants";

const _i18n = getLanguageScope('account');

export default class AccountView extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {changeAccountTab, account_tab, is_store_owner} = this.props;

    const panes = [
      {  menuItem: { key: ACCOUNT_TABS.TRANSACTIONS, icon: 'payment', content: _i18n('transactions') }, render: () => (
          <Tab.Pane active={account_tab === ACCOUNT_TABS.TRANSACTIONS} style={{border: 'none'}}>
            <Header as={'h3'} content={_i18n('transactions')}/>
            <TransactionsView/>
          </Tab.Pane>
        )
      },
      {  menuItem: { key: ACCOUNT_TABS.REPORTS, icon: 'list alternate', content: _i18n('reports') }, render: () => (
          <Tab.Pane active={account_tab === ACCOUNT_TABS.REPORTS} style={{border: 'none'}}>
            <Header as={'h3'} content={_i18n('reports')}/>
            <ReportsView/>
          </Tab.Pane>
        )
      }
    ];

    if(is_store_owner){
      panes.push(
        {  menuItem: { key: ACCOUNT_TABS.CLERKS, icon: 'user', content: _i18n('manage_employees') }, render: () => (
            <Tab.Pane active={account_tab === ACCOUNT_TABS.CLERKS} style={{border: 'none'}}>
              <Header as={'h3'} content={_i18n('manage_employees')}/>
              <ClerksView/>
            </Tab.Pane>
          )
        }
      )
    }

    return (
      <div>
        <Tab onTabChange={(e, data) => changeAccountTab(panes[data.activeIndex].menuItem.key)}
             menu={{ fluid: true, vertical: true }} menuPosition='left' panes={panes} />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/layouts/Content/components/AccountView.js